import { useCallback, useContext } from "react";
import { backendUrl } from "../services";
import { ReportsConfirmedContext } from "../context";
import { IConfirmedReport, IProjectManagerConfirmed, IRequestCoordinatorReportConfirm } from "../models/reportConfirm";


export const useReportsConfirmed = () => {
    const { 
        confirmedReports, 
        setConfirmedReports,
    } = useContext(ReportsConfirmedContext)

    const retrieveConfirmedReports = useCallback(async (contractId: string, dateID: string) =>   {
        const authToken = sessionStorage.getItem("token")
        const requestOptions = {
            method: 'GET',
            headers: {
                "Authorization": `Token ${authToken}`,
                "Content-Type": "application/json",
            },
        }
        await fetch(`${backendUrl}/api/reportConfirm/confirmedReports/${contractId}/${dateID}/`, requestOptions)
        .then(response => response.json())
        .then(response => {
            setConfirmedReports(response.data)
        })
        .catch(error => {
            console.error("Error:", error);
        })
        }, [setConfirmedReports])

    const createConfirmedReports = useCallback(async (request: IRequestCoordinatorReportConfirm) =>   {
        const authToken = sessionStorage.getItem("token")
        const requestOptions = {
            method: 'POST',
            headers: {
                "Authorization": `Token ${authToken}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(request)
        };
        await fetch(`${backendUrl}/api/reportConfirm/coordinatorReportConfirm/`, requestOptions)
        .then(response => response.json())
        .then(response => {
            setConfirmedReports(response.data)
            // console.log("*** response.data:", response.data)
        })
        .catch(error => {
            console.error("Error:", error);
        })
        }, [setConfirmedReports])
    
    const createManagerConfirmedProject = useCallback(async (request: IProjectManagerConfirmed) =>   {
        const authToken = sessionStorage.getItem("token")
        const requestOptions = {
            method: 'POST',
            headers: {
                "Authorization": `Token ${authToken}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(request)
        };
        await fetch(`${backendUrl}/api/reportConfirm/projectManagerReportConfirm/`, requestOptions)
        .then(response => response.json())
        .then(response => {
            setConfirmedReports(response.data)
        })
        .catch(error => {
            console.error("Error:", error);
        })
        }, [setConfirmedReports])

    const checkIsManagerConfirmPossible = () => {
        if(confirmedReports && confirmedReports.length > 0){
            const count = confirmedReports.filter(c => c.type > 0 && c.type < 17 && c.user_c) &&
                confirmedReports.filter(c => c.type > 0 && c.type < 17 && c.user_c).length > 0 ?
                confirmedReports.filter(c => c.type > 0 && c.type < 17 && c.user_c).length : 0;
            if(count === 16){
                return true;
            }
            return false;
        }
        return false;
    }

    const checkConfirmation = useCallback ((currentType: number) => {
        if(currentType > 0){
            if(confirmedReports && confirmedReports.length > 0 && 
                confirmedReports.some((c: IConfirmedReport) => c.type === currentType && c.user_c)){
                    const confirmedReport = confirmedReports.filter((c: IConfirmedReport) => 
                        c.type === currentType && c.user_c)[0]
                    return {
                        userConfirmer: confirmedReport.userconfirmer, 
                        isReportConfirmed: 'confirmed', 
                        confirmDate: confirmedReport.userconfirmshamsidate
                    }
                }
            else{
                return {
                    userConfirmer: '', 
                    isReportConfirmed: 'notConfirmed',
                    confirmDate: ''
                }
            }
        }
        else if(currentType === 0){
            if(confirmedReports && confirmedReports.length > 0 && 
                confirmedReports.some((c: IConfirmedReport) => c.pm_c)){
                    return {
                        userconfirmer: '', 
                        isReportConfirmed: 'confirmed',
                        confirmDate: ''
                    }
                }
            else{
                return {
                    userconfirmer: '', 
                    isReportConfirmed: 'notConfirmed',
                    confirmDate: ''
                }
            }
        }
        else{
            return {
                userconfirmer: '', 
                isReportConfirmed: 'notRequired',
                confirmDate: ''
            }
        }
    }, [confirmedReports])

  return{
    confirmedReports,
    retrieveConfirmedReports,
    createConfirmedReports,
    createManagerConfirmedProject,
    checkConfirmation,
    checkIsManagerConfirmPossible,
  }
}
